/* <surisa-spec-table> — tabla de especificaciones del PDP con toggle
   Métrico ↔ Imperial.

   Lee un dataset JSON inline { rows, cells } (rows = los column_def de
   table_config.spec_columns; cells = superset del producto, snippet
   spec-cell-dataset.liquid) y reusa el motor compartido window.SurisaUnits
   (resolveCellKey / formatValue / unitDisplayLabel).

   Es un custom element para que connectedCallback se re-ejecute tras el
   full-page re-render de variante que hace product-info.js (viewTransition).

   El SSR pinta las filas en métrico (mm) para SEO + first paint; este JS NO
   re-renderiza en el connect inicial (confía en el SSR), solo al togglear
   — mismo criterio que el catálogo (evita el flash de hidratación). */
(function () {
  'use strict';
  if (customElements.get('surisa-spec-table')) return;

  var U = window.SurisaUnits;

  customElements.define('surisa-spec-table', class extends HTMLElement {
    connectedCallback() {
      if (!U) { console.error('[surisa-spec-table] SurisaUnits no cargado'); return; }
      var script = this.querySelector('script[data-spec-dataset]');
      if (!script) return;
      try {
        this.data = JSON.parse(script.textContent);
      } catch (e) {
        console.error('[surisa-spec-table] dataset parse failed', e);
        return;
      }
      this.rowsEl = this.querySelector('[data-spec-rows]');
      this.unit = 'mm';

      var self = this;
      this.toggleBtns = Array.prototype.slice.call(
        this.querySelectorAll('[data-spec-unit-toggle] [data-unit]')
      );
      this.toggleBtns.forEach(function (btn) {
        btn.addEventListener('click', function () {
          var u = btn.getAttribute('data-unit');
          if ((u === 'mm' || u === 'in') && u !== self.unit) {
            self.unit = u;
            self.renderRows();
            self.syncToggle();
          }
        });
      });
      // Pintamos en connect (autoritativo). No usamos SSR de filas porque el
      // parse_json del SSR es inconsistente entre entornos Shopify; el dataset
      // (JSON.parse) sí es fiable.
      this.renderRows();
    }

    syncToggle() {
      var u = this.unit;
      this.toggleBtns.forEach(function (btn) {
        var on = btn.getAttribute('data-unit') === u;
        btn.classList.toggle('pdp__unit-btn--active', on);
        btn.setAttribute('aria-pressed', on ? 'true' : 'false');
      });
    }

    renderRows() {
      if (!this.rowsEl || !this.data) return;
      var rows = this.data.rows || [];
      var cells = this.data.cells || {};
      var unit = this.unit;
      var frag = document.createDocumentFragment();
      for (var i = 0; i < rows.length; i++) {
        var row = rows[i];
        var cellKey = U.resolveCellKey(row, unit);
        var raw = cells[cellKey];
        var val = U.formatValue(row, raw, unit);
        if (val == null) continue; // fila sin dato tras resolver → no se pinta
        var unitLabel = U.unitDisplayLabel(row.unit_base, unit, row.unit_display);
        var rowEl = document.createElement('div');
        rowEl.className = 'pdp__spec-row';
        // Clave = chip con el símbolo (label, ej. "De") + nombre completo en
        // bold (name, ej. "Diámetro exterior") si el column_def lo trae.
        var k = document.createElement('span');
        k.className = 'pdp__spec-k';
        if (row.label) {
          var sym = document.createElement('span');
          sym.className = 'pdp__spec-sym mono';
          sym.textContent = row.label;
          k.appendChild(sym);
        }
        if (row.name) {
          var nm = document.createElement('span');
          nm.className = 'pdp__spec-name';
          nm.textContent = row.name;
          k.appendChild(nm);
        }
        var v = document.createElement('span');
        v.className = 'pdp__spec-v mono';
        v.textContent = unitLabel ? (val + ' ' + unitLabel) : val;
        rowEl.appendChild(k);
        rowEl.appendChild(v);
        frag.appendChild(rowEl);
      }
      while (this.rowsEl.firstChild) this.rowsEl.removeChild(this.rowsEl.firstChild);
      this.rowsEl.appendChild(frag);
    }
  });
})();
